module.exports = __webpack_public_path__ + "static/media/general-terms-v1.5a42b39d.md";